<template>
  <div class="container-fluid">
    <titular />
    <vue-bootstrap4-table ref="tabla" :rows="rows" :columns="columns" :classes="classes" :config="config" :actions="actionsExportar" @exportarTabla="exportarTablaPrevio" @exportarBolcat="exportarBolcatPrevio">
      <template slot="empty-results">No hi ha cap revisió</template>
      <template slot="global-search-clear-icon">
        <i class="fa-solid fa-circle-xmark"></i>
      </template>
      <template slot="refresh-button-text">
        <i class="fa-solid fa-rotate" title="Actualitzar dades" @click="getData" v-tooltip></i>
      </template>
      <template slot="reset-button-text">
        <i class="fa-solid fa-eraser" title="Reiniciar vista" v-tooltip></i>
      </template>
      <template slot="sort-asc-icon">
        <i class="fa-solid fa-sort-up"></i>
      </template>
      <template slot="sort-desc-icon">
        <i class="fa-solid fa-sort-down"></i>
      </template>
      <template slot="no-sort-icon">
        <i class="fas fa-sort"></i>
      </template>
      <template slot="simple-filter-clear-icon">
        <i class="fa-solid fa-circle-xmark"></i>
      </template>
      <template slot="paginataion-previous-button">
        <i class="fa-solid fa-angle-left"></i>
      </template>
      <template slot="paginataion-next-button">
        <i class="fa-solid fa-angle-right"></i>
      </template>
      <template v-slot:pagination-info="props">
        Registres: {{ props.currentPageRowsLength }} de {{ props.filteredRowsLength }}<template v-if="props.filteredRowsLength !== props.originalRowsLength"> ({{ props.originalRowsLength }} en total)</template>
      </template>
      <template slot="selected-rows-info" slot-scope="props">{{ props }} Selecció: {{ props.selectedItemsCount }}</template>
      <template slot="criteri_1" slot-scope="props">
        <i v-show="props.cell_value" class="fa-solid fa-paper-plane"></i>
      </template>
      <template slot="criteri_2" slot-scope="props">
        <i v-show="props.cell_value" class="fa-solid fa-paper-plane"></i>
      </template>
      <template slot="criteri_3" slot-scope="props">
        <i v-show="props.cell_value" class="fa-solid fa-paper-plane"></i>
      </template>
      <template slot="criteri_4" slot-scope="props">
        <i v-show="props.cell_value" class="fa-solid fa-paper-plane"></i>
      </template>
    </vue-bootstrap4-table>
  </div>
</template>

<style lang="scss"></style>

<script>
export default {
  name: "HistoricRevisions",
  inject: ["exportarTabla", "exportarBolcat", "actionsExportar"],
  data() {
    return {
      loading: {
      },
      rows: [],
      rowsBuffer: [],
      columns: [
        {
          label: "#",
          name: "id",
          filter: {
            type: "simple",
            placeholder: "Filtra ID",
          },
          sort: true,
          row_text_alignment: "text-left",
        },
        {
          label: "Setmana any",
          name: "setmana_any",
          filter: {
            type: "simple",
            placeholder: "Filtra setmana",
          },
          sort: true,
          initial_sort: true,
          initial_sort_order: "desc",
          row_text_alignment: "text-left",
        },
        {
          label: "Treballador",
          name: "treballador",
          filter: {
            type: "simple",
            placeholder: "Filtra treballador",
          },
          sort: true,
          row_text_alignment: "text-left",
        },
        {
          label: "Criteri 1",
          name: "criteri_1",
          filter: {
            type: "select",
            mode: "single",
            closeDropdownOnSelection: true,
            placeholder: "Filtra criteri 1",
            options: [
              {
                name: "Enviat",
                value: 1,
              },
              {
                name: "No enviat",
                value: 0,
              },
            ],
          },
          sort: false,
          row_text_alignment: "text-center",
          slot_name: "criteri_1",
        },
        {
          label: "Criteri 2",
          name: "criteri_2",
          filter: {
            type: "select",
            mode: "single",
            closeDropdownOnSelection: true,
            placeholder: "Filtra criteri 2",
            options: [
              {
                name: "Enviat",
                value: 1,
              },
              {
                name: "No enviat",
                value: 0,
              },
            ],
          },
          sort: false,
          row_text_alignment: "text-center",
          slot_name: "criteri_2",
        },
        {
          label: "Criteri 3",
          name: "criteri_3",
          filter: {
            type: "select",
            mode: "single",
            closeDropdownOnSelection: true,
            placeholder: "Filtra criteri 3",
            options: [
              {
                name: "Enviat",
                value: 1,
              },
              {
                name: "No enviat",
                value: 0,
              },
            ],
          },
          sort: false,
          row_text_alignment: "text-center",
          slot_name: "criteri_3",
        },
        {
          label: "Criteri 4",
          name: "criteri_4",
          filter: {
            type: "select",
            mode: "single",
            closeDropdownOnSelection: true,
            placeholder: "Filtra criteri 4",
            options: [
              {
                name: "Enviat",
                value: 1,
              },
              {
                name: "No enviat",
                value: 0,
              },
            ],
          },
          sort: false,
          row_text_alignment: "text-center",
          slot_name: "criteri_4",
        },
      ],
      classes: {
        cell: {
          "align-middle": true,
        },
      },
      config: {
        card_title: "Revisions del darrer any",
        global_search: {
          placeholder: "Cerca",
        },
        per_page: 25,
        per_page_options: [25, 50, 100],
        num_of_visibile_pagination_buttons: 5,
      },
    };
  },
  methods: {
    getData: function () {
      this.$http.get("api/revisions").then((response) => this.rows = response.data);
    },
    exportarTablaPrevio() {
      this.exportarTabla(this.$route.name, this.$refs.tabla);
    },
    exportarBolcatPrevio() {
      this.exportarBolcat(this.$route.name, this.$refs.tabla);
    },
  },
  mounted() {
    this.getData();
  },
  watch: {
    rows: function (value) {
      this.rowsBuffer = structuredClone(value);
    },
  },
};
</script>